module.exports = __webpack_public_path__ + "img/home-right.1404417f.png";